enum RoomType {
  Private = 'private',
  Public = 'public',
  Direct = 'dm',
  Livestream = 'livestream',
}

export default RoomType;
